import { Button } from '@trackman/web-shared-components';
import './CartButton.scss';
import { ReactComponent as ShoppingCart } from 'images/icons/ShoppingCartThin.svg';
import { useCartStore } from 'stores/SubscriptionsAndPricing/CartStore';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const CartButton = () => {
  const itemsInCart = useCartStore((state) => state.items);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button className='cart-button' intent='primary' startIcon={<ShoppingCart />} onClick={() => navigate('Cart', { relative: 'path' })}>
      {t('ViewCart', { ns: 'subscriptionsAndPricing', numberOfItems: itemsInCart.length })}
    </Button>
  );
};
